module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/collegiate-mobile-76847c6fd50e5f206df2d4687a688ee7.jpg";